export const EXPERIMENT_CHOKE_POINT_SCHEMA_NAME =
  'experiment_choke_point.ExperimentChokePoint';
export const EXPERIMENT_CHOKE_POINT_MINIEVENT_NAME = 'ExperimentChokePoint';
